import { Dialog } from './Dialog'
import { useOrderHistory } from '../hooks/useOrderHistory'
import { OrderItemType } from '../types'
import { Copyable } from '~/components/ui/Copyable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHistory } from '@fortawesome/free-solid-svg-icons'

function Cell({ name, value }: { name: string; value: string }) {
    return (
        <div className='flex flex-col'>
            <div className='text-2xs text-white/30 uppercase mt-2'>{name}</div>
            <div className='mb-2'>{value}</div>
        </div>
    )
}

function OrderHistoryListItem({ item }: { item: OrderItemType }) {
    return (
        <>
            <Cell name='name' value={item.asset_name} />
            <Cell name='order' value={item.order_status} />
            <Cell name='delivery' value={item.delivery_status} />
            <Cell name='id' value={item.uuid} />
        </>
    )
}

function OrderHistoryList() {
    const { items, isFetched } = useOrderHistory()
    return (
        <div className='max-h-full flex flex-col'>
            <header className='grid grid-cols-[1fr_auto] font-bold border-b border-white/20 p-4 gap-x-4 items-center'>
                <div className='whitespace-nowrap overflow-hidden overflow-ellipsis'>Order History</div>
                <Dialog.Close />
            </header>
            {isFetched && (
                <div className='flex-1 overflow-auto grid grid-cols-4 p-4 max-w-[100vw]'>
                    {items?.length
                        ? items?.map((item) => <OrderHistoryListItem key={item.uuid} item={item} />)
                        : 'No orders found.'}
                </div>
            )}
        </div>
    )
}

export function OrderHistory() {
    return (
        <Dialog>
            <Dialog.Trigger>
                <button className='self-start flex flex-row gap-2 items-center px-4 hover:underline underline-offset-4'>
                    <small className='uppercase tracking-wider'>Order History</small>
                    <FontAwesomeIcon icon={faHistory} />
                </button>
            </Dialog.Trigger>
            <Dialog.Content>
                <OrderHistoryList />
            </Dialog.Content>
        </Dialog>
    )
}
